import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { SectionsService } from '../../../../services/sections.service';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-payable-provider-rates-list',
  standalone: true,
  imports: [ButtonComponent, ListTableComponent],
  templateUrl: './payable-provider-rates-list.component.html',
  styleUrl: './payable-provider-rates-list.component.css',
})
export class PayableProviderRatesListComponent {
  sharedDataKey: string = STATIC_DATA.SHARED_PARTICIPANT_PROVIDER_RATES_DATA;
  pageId: string = PAGE_CONSTANTS.PAYABLE_PROVIDER_RATES_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(
    private router: Router,
    private sharedDataService: SharedDataService,
    private sectionService: SectionsService, private claimsService: ClaimsService, private userService: UserService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }
  
  onAddParticipantProviderRates() {
    this.router.navigate(['/home/addPayablePersonalAssistantRates','add']);
  }

  rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('associationRates');
    this.sectionService.setFlow('associationRates');
    this.userService.setSelectedId(rowDetail.payRateId);
      this.claimsService.getPayableProviderRates(
          program?.program_code,
          rowDetail.payRateId,
          false
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('association_rates', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/addPayablePersonalAssistantRates', 'update']);
          }, 200);
        });
  }

  private setPageAccess() {
    const pageConfig = this.allowListStore.getConfig()?.pages[this.pageId];
    if (pageConfig) {
      const allowedActions = this.allowListStore.getAllowedActions(this.pageId);
      const allowedButtons = this.allowListStore.getAllowedButtons(this.pageId);
      this.isReadOnly = allowedActions.length === 0 && allowedButtons.length === 0;
    } else {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
